import styles from './PopoverMenu.module.scss'
import { Arrow } from '@app/icons'
import { Popover } from 'antd'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

export const PopoverMenu = memo(({
																	 actions = [],
																	 handleClickItem,
																 }) => {
	const { t } = useTranslation()

	const list = actions?.map((item, index) => (
		<li key={item?.action} onClick={() => {
			handleClickItem(item.action)
		}}>
			<div>
				{item.icon}
			</div>
			<div>
				{item?.title}
			</div>
		</li>
	))

	return (
		<Popover
			placement="bottomRight"
			overlayClassName={'actions'}
			zIndex={50}
			trigger="click"
			content={(
				<ul className={`${styles.list} `}>
					{list}
				</ul>
			)}
		>
			<button type={'button'} className={styles.dropdownButton}>
				{t('select_pls')}<Arrow className={styles.icon} />
			</button>
		</Popover>
	)
})